import { render, staticRenderFns } from "./TaskDispatcher.vue?vue&type=template&id=be758fb8&"
import script from "./TaskDispatcher.vue?vue&type=script&lang=js&"
export * from "./TaskDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports